<template>
  <div class="text-center">
    <v-dialog
      v-model="flag"
      width="950"
      height="400"
      class="not-scroll"
      scrollable
    >
      <v-card @mousemove="keyboardMode = false" class="not-scroll">
        <!-- Title bar -->
        <v-card-title
          class="py-3 px-4 text-truncate dialog-title-border dark-purple-text"
        >
          <div class="d-flex justify-center align-center font-weight-bold" style="width: 90%">
            General Search
          </div>

          <v-spacer></v-spacer>
          <v-icon small color="#757096" @click="(flag = false), (search = null)"
            >mdi-close</v-icon
          >
        </v-card-title>

        <v-card-text class="mt-4">
          <!-- <div class="grey--text text--darken-1 text-caption my-2 mt-n1">
            Type to find. Use ↑↓ to browse, ↵ to select, ESC to dismiss.
          </div> -->
          <div class="dark-purple-text body-2">
           Type here to find any task, workspace, project and member.
          </div>
          <div class="theme-border mt-2 rounded">
            <v-text-field
              id="text-field"
              autocomplete="off"
              prepend-inner-icon="mdi-magnify"
              background-color="white"
              placeholder="Search any task, workspace, project and member..."
              class="body-2"
              color="#757096"
              hide-details
              solo
              flat
              dense
              autofocus
              v-model="search"
              @keydown.up="selectItemOnKeys"
              @keydown.down="selectItemOnKeys"
              @keydown.right="right()"
              @keydown.left="left()"
              @keydown.enter="selectItemOnKeys"
            >
            </v-text-field>
          </div>
          <v-progress-linear
            v-if="fetchRoleLoader"
            indeterminate
            class="progress-bar-borders mt-2"
          ></v-progress-linear>
          <v-row v-if="search" class="d-flex my-2" :class="search ? 'table-header-bg' : ''" no-gutters>
            <v-col cols="3">
            <v-list-item>
              <div class="font-weight-bold">
                Tasks
              </div></v-list-item
            >
            </v-col>
            <v-col cols="3">
              <v-list-item
              >
                <div class="font-weight-bold">Companies</div>
              </v-list-item>
            </v-col>
            <v-col cols="3">
              <v-list-item
              >
                <div class="font-weight-bold">Projects</div>
              </v-list-item>
            </v-col>
            <v-col cols="3">
              <v-list-item
              >
                <div class="font-weight-bold">Members</div>
              </v-list-item>
            </v-col>
          </v-row>
          <v-row
            :class="isMac ? 'edited_scrollbar' : ''"
            class="d-flex ma-0 pa-0"
          >
            <v-col cols="3" class="pa-0">
              <v-list
                max-height="250"
                class="overflow-scroll"
              >
                <v-list-item
                  ref="searchFocusTask"
                  v-for="(task, index) in searchedTasks"
                  :key="index"
                  :input-value="index == focusTask"
                  @mouseover="
                    (focusTask = index),
                      (focusCompany = null),
                      (focusProject = null),
                      (focusMember = null)
                  "
                  @click="selectTask(searchedTasks[focusTask])"
                  :class="[focusTask == index ? 'bg-selected' : '']"
                  class="overflow-scroll pointer"
                  >
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    bottom
                    open-delay="300"
                    color="#DCD8F3"
                  >
                  <template v-slot:activator="{ on }">
                  <v-btn fab x-small elevation="0" color="#1cc283" outlined style="width:27px; height:27px">
                  <v-icon rounded small>mdi-clipboard-text</v-icon>
                  </v-btn>
                  <div
                    v-on="on"
                    class="text-truncate text-capitalize ml-2"
                  >
                    {{ task.task_title }}
                  </div>
                  </template>
                  <span class="font-weight-bold dark-purple-text">{{task.task_title}}</span>
                  </v-tooltip>
                </v-list-item>
                <div class="d-flex" v-if="search && !searchedTasks.length">
                  <p class="no-results-found flex-start my-1 mx-2">No results found.</p>
                </div>
              </v-list>
            </v-col>
            <v-col cols="3" class="pa-0">
              <v-list
                max-height="250"
                class="overflow-scroll"
              >
                <v-list-item
                  ref="searchFocusCompany"
                  v-for="(company, index) in searchedCompanies"
                  :key="index"
                  :input-value="index == focusCompany"
                  @mouseover="
                    (focusCompany = index),
                      (focusProject = null),
                      (focusMember = null),
                      (focusTask = null)
                  "
                  @click="selectCompany(searchedCompanies[focusCompany].id)"
                  :class="focusCompany == index ? 'bg-selected' : ''"
                  class="overflow-scroll pointer"
                  >
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    bottom
                    open-delay="300"
                    color="#DCD8F3"
                  >
                  <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex">
                    <ProfileImage
                      inline
                      v-show="company.logo ? ':src' : ':username'"
                      :src="company.logo"
                      :username="company.name"
                      :size="25"
                      :circular="true"
                      :userProfile="true"
                      class="mr-2 text-light">
                    </ProfileImage>
                    <v-badge
                      v-if="company.id == getSelectedCompany.id"
                      color="green"
                      dot
                      class="mt-5 ml-n2"
                    ></v-badge>
                    <div
                      :class="company.id == getSelectedCompany.id ? 'ml-2 font-weight-bold' : ''"
                      class="d-inline-block text-truncate text-capitalize"
                      style="max-width:130px"
                    >
                      {{ company.name }}
                    </div>
                  </div>
                  </template>
                 <span class="font-weight-bold dark-purple-text">{{company.name}}</span>
                </v-tooltip>
                  <v-badge
                  v-if="company.comment_count"
                  :content="company.comment_count"
                  class="mt-3 ml-5"
                  color="red"
                ></v-badge>
                </v-list-item>
                <div class="d-flex" v-if="search && !searchedCompanies.length">
                  <p class="no-results-found flex-start my-1 mx-2">No results found.</p>
                </div>
              </v-list>
            </v-col>
            <v-col cols="3" class="pa-0">
              <v-list
                max-height="250"
                class="overflow-scroll"
              >
                <v-list-item
                  ref="searchFocusProject"
                  v-for="(project, index) in searchedProjects"
                  :key="index"
                  :input-value="index == focusProject"
                  @mouseover="
                    (focusProject = index),
                      (focusCompany = null),
                      (focusMember = null),
                      (focusTask = null)
                  "
                  @click="selectProject(searchedProjects[focusProject])"
                  :class="focusProject == index ? 'bg-selected' : ''"
                  class="overflow-scroll pointer"
                  >
                   <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    bottom
                    open-delay="300"
                    color="#DCD8F3"
                  >
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-flex">
                      <!-- <ProfileImage  
                        inline
                        v-show="':username'"
                        :username="project.name"
                        :size="25"
                        :circular="true"
                        :userProfile="true"
                        class="mr-2 text-light">
                      </ProfileImage> -->
                      <v-btn fab x-small elevation="0" color="#1cc283" outlined style="width:27px; height:27px">
                      <v-icon rounded small>mdi-text-box-outline</v-icon>
                      </v-btn>
                      <div
                        class="d-inline-block text-truncate text-capitalize ml-2"
                        style="max-width:170px"
                      >
                        {{ project.name }}
                      </div>
                    </div>
                  </template>
                    <span class="font-weight-bold dark-purple-text">{{project.name}}</span>
                   </v-tooltip>
                </v-list-item>
                <div class="d-flex" v-if="search && !searchedProjects.length">
                  <p class="no-results-found flex-start my-1 mx-2">No results found.</p>
                </div>
              </v-list>
            </v-col>
            <v-col cols="3" class="pa-0">
              <v-list
                max-height="250"
                class="overflow-scroll"
              >
                <v-list-item
                  ref="searchFocusMember"
                  v-for="(member, index) in searchedMembers"
                  :key="index"
                  :input-value="index == focusMember"
                  @mouseover="
                    (focusMember = index),
                      (focusCompany = null),
                      (focusProject = null),
                      (focusTask = null)
                  "
                  @click="selectMember(searchedMembers[focusMember])"
                  :class="focusMember == index ? 'bg-selected' : ''"
                  class="overflow-scroll pointer"
                  >
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    bottom
                    open-delay="300"
                    color="#DCD8F3"
                  >
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-flex">
                      <ProfileImage  
                        inline
                        v-show="member.image ? ':src' : ':username'"
                        :src="member.image"
                        :username="member.name ? member.name : member.email"
                        :size="25"
                        :circular="true"
                        :userProfile="true"
                        class="mr-2 text-light">
                      </ProfileImage>
                      <div
                        class="d-inline-block text-truncate"
                        :class="member.name ? 'text-capitalize' :''"
                        style="max-width:170px"
                      >
                        {{ member.name ? member.name : member.email }}
                      </div>
                    </div>
                  </template>
                  <span class="font-weight-bold dark-purple-text">{{member.name ? member.name : member.email}}</span>
                  </v-tooltip>
                </v-list-item>
                <div class="d-flex" v-if="search && !searchedMembers.length">
                  <p class="no-results-found flex-start my-1 mx-2">No results found.</p>
                </div>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { updateUserRole } from "@/mixins/updateUserRole";
import { eventBus } from "@/main";
import moment from "moment";
export default {
  mixins: [updateUserRole],
  components: { 
    ProfileImage: () => import("@/components/Includes/ProfileImage"),
  },
  data() {
    return {
      fetchRoleLoader: false,
      absolute: true,
      flag: false,
      search: null,
      focusCompany: null,
      focusProject: null,
      focusMember: null,
      focusTask: 0,
      keyboardMode: false,
      timer: -1,
      dateRangeFilter: null,
    };
  },
  computed: {
    ...mapGetters([
      "getCompanies",
      "getProjects",
      "getProjectAssociatedMembers",
      "getTaskComments",
      "getSearchedComments",
    ]),
    searchedCompanies() {
      return this.search
        ? this.getCompanies
          ? this.getCompanies.filter((item) => {
              return item.name
                ? item.name.toLowerCase().includes(this.search.toLowerCase())
                : false;
            })
          : []
        : [];
    },
    searchedProjects() {
      return this.search
        ? this.getProjects
          ? this.getProjects.filter((item) => {
              return item.name
                ? item.name.toLowerCase().includes(this.search.toLowerCase())
                : false;
            })
          : []
        : [];
    },
    searchedMembers() {
      return this.search
        ? this.getProjectAssociatedMembers
          ? this.getProjectAssociatedMembers.filter((item) => {
              return item.name
                ? item.name.toLowerCase().includes(this.search.toLowerCase())
                : item.email.toLowerCase().includes(this.search.toLowerCase());
            })
          : []
        : [];
    },
    searchedTasks() {
      return this.getTaskComments;
    },
  },
  mounted() {
    window.onkeydown = (event) => {
      if (
        (event.metaKey && event.key == "k") ||
        (event.ctrlKey && event.key == "k")
      ) {
        event.preventDefault();
        this.flag = true;
      }
    };
  },
  methods: {
    filteredSearchedComments(task_id) {
      return this.getSearchedComments(task_id);
    },
    clearStates() {
      this.searchedTasks.length
        ? ((this.focusTask = 0),
          (this.focusCompany = null),
          (this.focusProject = null),
          (this.focusMember = null))
        : this.searchedCompanies.length
        ? ((this.focusCompany = 0),
          (this.focusProject = null),
          (this.focusMember = null),
          (this.focusTask = null))
        : this.searchedProjects.length
        ? ((this.focusProject = 0),
          (this.focusMember = null),
          (this.focusTask = null),
          (this.focusCompany = null))
        : this.searchedMembers.length
        ? ((this.focusMember = 0),
          (this.focusTask = null),
          (this.focusCompany = null),
          (this.focusProject = null))
        : () => {};
    },
    searchTitle() {
      this.search
        ? ((this.fetchRoleLoader = true),
          this.$store
            .dispatch("fetchTasksCommentsSearch", {
              title: this.search,
            })
            .then(() => {
              this.fetchRoleLoader = false;
              this.clearStates();
            }))
        : this.$store.commit("setTaskComments", []);
    },
    right() {
      if (this.focusTask == 0 || this.focusTask) {
        this.focusTask = null;
        if (this.searchedCompanies.length) {
          this.focusCompany = 0;
          this.searchedCompanies.length
            ? this.searchCompanyScrollTop()
            : () => {};
        } else if (this.searchedProjects.length) {
          this.focusProject = 0;
          this.searchedProjects.length
            ? this.searchProjectScrollTop()
            : () => {};
        } else if (this.searchedMembers.length) {
          this.focusMember = 0;
          this.searchedMembers.length ? this.searchMemberScrollTop() : () => {};
        } else {
          this.focusTask = 0;
          this.searchedTasks.length ? this.searchTaskScrollTop() : () => {};
        }
      } else if (this.focusCompany == 0 || this.focusCompany) {
        this.focusCompany = null;
        if (this.searchedProjects.length) {
          this.focusProject = 0;
          this.searchedProjects.length
            ? this.searchProjectScrollTop()
            : () => {};
        } else if (this.searchedMembers.length) {
          this.focusMember = 0;
          this.searchedMembers.length ? this.searchMemberScrollTop() : () => {};
        } else {
          this.focusCompany = 0;
          this.searchedCompanies.length
            ? this.searchCompanyScrollTop()
            : () => {};
        }
      } else if (this.focusProject == 0 || this.focusProject) {
        this.focusProject = null;
        if (this.searchedMembers.length) {
          this.focusMember = 0;
          this.searchedMembers.length ? this.searchMemberScrollTop() : () => {};
        } else {
          this.focusProject = 0;
          this.searchedProjects.length
            ? this.searchProjectScrollTop()
            : () => {};
        }
      } else () => {};
    },
    left() {
      if (this.focusMember == 0 || this.focusMember) {
        this.focusMember = null;
        if (this.searchedProjects.length) {
          this.focusProject = 0;
          this.searchedProjects.length
            ? this.searchProjectScrollTop()
            : () => {};
        } else if (this.searchedCompanies.length) {
          this.focusCompany = 0;
          this.searchedCompanies.length
            ? this.searchCompanyScrollTop()
            : () => {};
        } else if (this.searchedTasks.length) {
          this.focusTask = 0;
          this.searchedTasks.length ? this.searchTaskScrollTop() : () => {};
        } else {
          this.focusMember = 0;
          this.searchedMembers.length ? this.searchMemberScrollTop() : () => {};
        }
      } else if (this.focusProject == 0 || this.focusProject) {
        this.focusProject = null;
        if (this.searchedCompanies.length) {
          this.focusCompany = 0;
          this.searchedCompanies.length
            ? this.searchCompanyScrollTop()
            : () => {};
        } else if (this.searchedTasks.length) {
          this.focusTask = 0;
          this.searchedTasks.length ? this.searchTaskScrollTop() : () => {};
        } else {
          this.focusProject = 0;
          this.searchedProjects.length
            ? this.searchProjectScrollTop()
            : () => {};
        }
      } else if (this.focusCompany == 0 || this.focusCompany) {
        this.focusCompany = null;
        if (this.searchedTasks.length) {
          this.focusTask = 0;
          this.searchedTasks.length ? this.searchTaskScrollTop() : () => {};
        } else {
          this.focusCompany = 0;
          this.searchedCompanies.length
            ? this.searchCompanyScrollTop()
            : () => {};
        }
      } else () => {};
    },
    selectItemOnKeys(event) {
      document.getElementById("text-field").focus();
      if (this.focusCompany || this.focusCompany == 0) {
        switch (event.key) {
          case "ArrowUp":
            event.preventDefault();
            if (this.focusCompany > 0) {
              this.keyboardMode = true;
              this.focusCompany--;
              this.searchCompanyScroll();
            }
            break;
          case "ArrowDown":
            if (this.focusCompany < this.searchedCompanies.length - 1) {
              this.keyboardMode = true;
              this.focusCompany++;
              this.searchCompanyScroll();
            }
            break;
          case "Enter":
            if (this.focusCompany >= 0 && this.searchedCompanies.length) {
              this.selectCompany(this.searchedCompanies[this.focusCompany].id);
            }
        }
      } else if (this.focusProject || this.focusProject == 0) {
        switch (event.key) {
          case "ArrowUp":
            event.preventDefault();
            if (this.focusProject > 0) {
              this.keyboardMode = true;
              this.focusProject--;
              this.searchProjectScroll();
            }
            break;
          case "ArrowDown":
            if (this.focusProject < this.searchedProjects.length - 1) {
              this.keyboardMode = true;
              this.focusProject++;
              this.searchProjectScroll();
            }
            break;
          case "Enter":
            if (this.focusProject >= 0 && this.searchedProjects.length) {
              this.selectProject(this.searchedProjects[this.focusProject]);
            }
        }
      } else if (this.focusMember || this.focusMember == 0) {
        switch (event.key) {
          case "ArrowUp":
            event.preventDefault();
            if (this.focusMember > 0) {
              this.keyboardMode = true;
              this.focusMember--;
              this.searchMemberScroll();
            }
            break;
          case "ArrowDown":
            if (this.focusMember < this.searchedMembers.length - 1) {
              this.keyboardMode = true;
              this.focusMember++;
              this.searchMemberScroll();
            }
            break;
          case "Enter":
            if (this.focusMember >= 0 && this.searchedMembers.length) {
              this.selectMember(this.searchedMembers[this.focusMember]);
            }
        }
      } else if (this.focusTask || this.focusTask == 0) {
        switch (event.key) {
          case "ArrowUp":
            event.preventDefault();
            if (this.focusTask > 0) {
              this.keyboardMode = true;
              this.focusTask--;
              this.searchTaskScroll();
            }
            break;
          case "ArrowDown":
            if (this.focusTask < this.searchedTasks.length - 1) {
              this.keyboardMode = true;
              this.focusTask++;
              this.searchTaskScroll();
            }
            break;
          case "Enter":
            if (this.focusTask >= 0 && this.searchedTasks.length) {
              this.selectTask(this.searchedTasks[this.focusTask]);
            }
        }
      }
    },
    searchCompanyScroll() {
      this.$refs.searchFocusCompany[this.focusCompany].$el.scrollIntoView({
        block: "end",
      });
    },
    searchCompanyScrollTop() {
      this.$refs.searchFocusCompany[this.focusCompany].$el.scrollIntoView({
        block: "start",
      });
    },
    searchProjectScroll() {
      this.$refs.searchFocusProject[this.focusProject].$el.scrollIntoView({
        block: "end",
      });
    },
    searchProjectScrollTop() {
      this.$refs.searchFocusProject[this.focusProject].$el.scrollIntoView({
        block: "start",
      });
    },
    searchMemberScroll() {
      this.$refs.searchFocusMember[this.focusMember].$el.scrollIntoView({
        block: "end",
      });
    },
    searchMemberScrollTop() {
      this.$refs.searchFocusMember[this.focusMember].$el.scrollIntoView({
        block: "start",
      });
    },
    searchTaskScroll() {
      this.$refs.searchFocusTask[this.focusTask].$el.scrollIntoView({
        block: "end",
      });
    },
    searchTaskScrollTop() {
      this.$refs.searchFocusTask[this.focusTask].$el.scrollIntoView({
        block: "start",
      });
    },
    selectCompany(id) {
      if (this.getScreenRecorderState) {
        return;
      }
      if (this.getActiveTask) {
        this.openSnackbar(true, "Please stop your task");
      } else {
        this.$store.commit("setTasksSkeletonLoader", true);
        if (this.$route.name != "task" && localStorage.getItem("user"))
          this.$router.push({
            name: "task",
          });
        eventBus.$emit("companySwitched");
        this.flag = false;
        this.$store.commit("setMembers", []);
        this.$store.commit("setProjectAssociatedMembers", []);
        this.$store.commit("setDepartments", []);
        this.$store.commit("setDesignations", []);
        this.$store.commit("setSelectedProject", null);
        this.$store.dispatch("updateLastCompany", {
          company_id: id,
        });
        this.$store.dispatch("selectCompany", id).then(() => {
          this.search = null;
          this.updateRole();
          this.$store.commit("resetDashboardFilters");
          this.$store.dispatch("fetchProjects");
          this.$store.dispatch("fetchTeamMembers");
          this.$store.dispatch("fetchProjectAssociatedMembers");
          this.$store.dispatch("fetchDepartments");
          this.$store.dispatch("fetchDesignations");
          this.$store.dispatch("fetchLabels");
          eventBus.$emit("closeCommentDialog", false);
        });
      }
    },
    selectProject(project) {
      eventBus.$emit("closeCommentDialog", false);
      this.dateRangeFilter = ["2000-01-01", moment().format("YYYY-MM-DD")];
      this.$store.commit("setTaskFilter", {
        status: "pending",
        assigned_to: [],
        start_date: this.dateRangeFilter[0],
        end_date: this.dateRangeFilter[1],
        show_tasks: this.getSelectedCompany.role == "employee" ? "me" : "all",
        redirect: status == "pending" ? true : false,
        page: 1,
        title: null,
        project_id: [project.id],
        assigned_by: [],
        report: false,
      });
      this.$store.dispatch("fetchTasks");
      if (this.$route.name != "task" && localStorage.getItem("user")) {
        localStorage.setItem("redirection", true);
        this.$router.push({
          name: "task",
        });
      }
      this.flag = false;
    },
    selectMember(member) {
      eventBus.$emit("closeCommentDialog", false);
      this.dateRangeFilter = ["2000-01-01", moment().format("YYYY-MM-DD")];
      this.$store.commit("setTaskFilter", {
        status: "pending",
        assigned_to: [member],
        start_date: this.dateRangeFilter[0],
        end_date: this.dateRangeFilter[1],
        show_tasks: this.getSelectedCompany.role == "employee" ? "me" : "all",
        redirect: status == "pending" ? true : false,
        page: 1,
        title: null,
        project_id: [],
        assigned_by: [],
        report: false,
      });
      this.$store.dispatch("fetchTasks");
      if (this.$route.name != "task" && localStorage.getItem("user")) {
        localStorage.setItem("redirection", true);
        this.$router.push({
          name: "task",
        });
      }
      this.flag = false;
    },
    selectTask(task) {
      if (this.$route.path.slice(0, 5) != "/task") {
        localStorage.setItem("redirection", true);
        this.$router.push(`/task/${task.id}`);
      } else {
        this.$router.push(`/task/${task.id}`);
        location.reload();
        eventBus.$emit("new-comment", {
          title: task.task_title,
          task_id: task.id,
        });
      }
      this.flag = false;
    },
  },
  watch: {
    flag(value) {
      this.$store.commit("setTaskComments", []);
      if (!value) {
        this.search = null;
        this.focusTask = 0;
        this.focusCompany = null;
        this.focusProject = null;
        this.focusMember = null;
      }
    },
    search() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.searchTitle();
      }, 1000);
      this.clearStates();
    },
  },
};
</script>
<style scoped>
.not-scroll {
  overflow: hidden;
}
.theme--light.v-list-item--active:before,
.theme--light.v-list-item--active:hover:before,
.theme--light.v-list-item:focus:before {
  opacity: 0 !important;
}
</style>
